import React, { useEffect, useMemo, useState } from 'react';
import Content from './components/Content';
import Group from './components/Group';
import Tab from './components/Tab';
import TabPane from './components/TabPane';
import { TabsContext } from './context';
import styles from './Tabs.module.scss';
const Tabs = ({ activeTab: initialActiveTab, onChange, children, }) => {
    const [activeTab, setActiveTab] = useState(initialActiveTab ?? null);
    const value = useMemo(() => ({ activeTab, setActiveTab }), [activeTab]);
    useEffect(() => {
        if (onChange) {
            onChange(activeTab);
        }
    }, [activeTab, onChange]);
    return (React.createElement(TabsContext.Provider, { value: value },
        React.createElement("div", { className: styles.tabsContainer }, children)));
};
Tabs.Tab = Tab;
Tabs.Pane = TabPane;
Tabs.Group = Group;
Tabs.Content = Content;
export default Tabs;
